/**
 * Configuration for sidebar menus.
 * Add the caption of any database-driven menu here to render it as a collapsible submenu in the sidebar.
 * This prevents other menus with database submenus (like "Settings") from being modified.
 */
export const COLLAPSIBLE_SIDEBAR_MENUS = [
  "Data Management",
  "Audit",
  "Supplier"
];

/**
 * A menu item belongs to the supplier section when the backend tags it with
 * `section: "supplier"` (from `riu_company_permission_copy.section`). Everything
 * else renders in the company section. Fully data-driven — no URL list to keep
 * in sync when supplier tabs change.
 */
export const isSupplierSectionMenu = (item) => item?.section === "supplier";

/**
 * Short pills rendered beside a menu caption, keyed by that exact caption.
 *
 * Keyed by caption rather than url or id because the menu id differs per
 * environment — the same row is 70 locally and 79 on developer — so an id here
 * would silently badge the wrong item, or nothing at all. Captions are the one
 * field the sidebar already special-cases on and that stays stable across
 * environments.
 */
export const NAV_BADGES = {
  "AI Competitor Analysis": "AI",
};
